<section id="homeowners-insurance-page" class="w-full min-h-screen bg-ld-neutral-50">
  <div class="bg-white border-b border-ld-border">
    <div class="max-w-page mx-auto py-6 page-content-padding">
      <header id="homeowners-insurance-header">
        <h1 id="homeowners-insurance-title" class="text-page-title">
          {{ 'homeownersInsurancePageTitle' | transloco }}
        </h1>
        <p id="homeowners-insurance-subtitle" class="text-base text-ld-neutral-500 mt-2">
          {{ 'homeownersInsuranceSubtitle' | transloco }}
        </p>
      </header>
    </div>
  </div>

  <div class="max-w-page mx-auto py-6 page-content-padding">
    <div class="grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-6">
      <div id="homeowners-insurance-content-section" class="flex flex-col gap-6">
        <div>
          <h2 id="homeowners-insurance-update-heading" class="text-section-heading text-ld-primary mb-3">
            {{ 'homeownersInsuranceUpdateTitle' | transloco }}
          </h2>
          <p id="homeowners-insurance-update-description" class="text-body text-ld-neutral-600 leading-relaxed">
            {{ 'homeownersInsuranceUpdateDescPart1' | transloco }}
            <a
              id="homeowners-insurance-here-link"
              [href]="expressInsuranceUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="text-ld-link font-medium hover:underline cursor-pointer"
            >
              {{ 'homeownersInsuranceUpdatePolicyLink' | transloco }}
            </a>
            {{ 'homeownersInsuranceUpdateDescPart2' | transloco }}
          </p>
        </div>

        <div class="card-base-sm p-6">
          <h2 id="homeowners-insurance-upload-heading" class="text-section-heading text-ld-primary mb-4">
            {{ 'homeownersInsuranceUploadTitle' | transloco }}
          </h2>

          <ol
            id="homeowners-insurance-steps"
            class="list-decimal list-outside ml-4 space-y-4 text-sm text-ld-neutral-700"
          >
            <li id="homeowners-insurance-step-1">
              {{ 'homeownersInsuranceStep1Part1' | transloco }}
              <br />
              <a
                id="homeowners-insurance-update-link"
                [href]="expressInsuranceUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="text-ld-link font-medium hover:underline cursor-pointer"
              >
                {{ 'homeownersInsuranceUpdatePolicyLink' | transloco }}
              </a>
            </li>

            <li id="homeowners-insurance-step-2">
              {{ 'homeownersInsuranceStep2' | transloco }}
              <ul class="list-disc list-outside ml-4 mt-2 space-y-1">
                <li>{{ 'homeownersInsuranceStep2Item1' | transloco }}</li>
                <li>{{ 'homeownersInsuranceStep2Item2' | transloco }}</li>
                <li>{{ 'commonCommonFieldsEmail' | transloco }}</li>
                <li>{{ 'propertyAddress' | transloco }}</li>
                <li>{{ 'commonMailingAddress' | transloco }}</li>
                <li>{{ 'commonFieldsLoanNumber' | transloco }}</li>
                <li>{{ 'homeownersInsuranceStep2Item7' | transloco }}</li>
                <li>{{ 'homeownersInsuranceStep2Item8' | transloco }}</li>
              </ul>
            </li>

            <li id="homeowners-insurance-step-3">{{ 'homeownersInsuranceStep3' | transloco }}</li>

            <li id="homeowners-insurance-step-4">{{ 'homeownersInsuranceStep4' | transloco }}</li>

            <li id="homeowners-insurance-step-5">{{ 'homeownersInsuranceStep5' | transloco }}</li>
          </ol>
        </div>

        <div id="homeowners-insurance-contact-link">
          <button
            type="button"
            class="inline-flex items-center gap-1 text-ld-link font-medium hover:underline cursor-pointer bg-transparent border-none p-0"
            (click)="openSecureMessage()"
          >
            {{ 'homeownersInsuranceContactSupport' | transloco }}
            <mat-icon class="size-5! text-xl!" aria-hidden="true">arrow_forward</mat-icon>
          </button>
        </div>
      </div>

      <aside id="homeowners-insurance-sidebar" class="flex flex-col gap-6">
        <ld-contact-card />
      </aside>
    </div>
  </div>

  @if (showComposeMessage()) {
    <div
      id="homeowners-insurance-compose-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="homeowners-insurance-compose-title"
      class="fixed inset-0 bg-black/50 flex items-center justify-center z-60 max-sm:bg-white max-sm:top-[calc(env(safe-area-inset-top)+60px)] max-sm:bottom-[calc(env(safe-area-inset-bottom)+60px)]"
      (keydown.escape)="onCloseComposeMessage()"
    >
      <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
      <div
        id="homeowners-insurance-compose-modal"
        class="bg-white rounded-card shadow-modal w-full max-w-2xl mx-4 max-h-[90vh] overflow-hidden max-sm:mx-0 max-sm:rounded-none max-sm:max-h-full max-sm:h-full max-sm:shadow-none"
        (click)="$event.stopPropagation()"
      >
        @defer (when showComposeMessage()) {
          <ld-compose-message
            [prefillCategory]="prefillCategory"
            [prefillTopic]="prefillTopic"
            (closed)="onCloseComposeMessage()"
          ></ld-compose-message>
        }
      </div>
    </div>
  }
</section>
